(function () {
  if (window.__cnsNavSplitsBound) return;
  window.__cnsNavSplitsBound = true;

  var roots = [];
  var ticking = false;

  function headerOffset() {
    var header = document.querySelector('sticky-header') || document.querySelector('#shopify-section-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function isSideNav(nav) {
    var layout = nav && nav.closest('.cns-layout');
    return layout && window.getComputedStyle(layout).flexDirection === 'row';
  }

  function markerY(root) {
    var y = headerOffset() + 20;
    var nav = root.querySelector('.cns-nav');
    if (!nav || isSideNav(nav)) return y;

    var position = window.getComputedStyle(nav).position;
    if (position === 'sticky' || position === 'fixed') {
      y += nav.getBoundingClientRect().height;
    }
    return y;
  }

  function setActiveLink(root, link) {
    if (!link || link.classList.contains('is-active')) return;
    var current = root.querySelectorAll('.cns-nav-link.is-active');
    for (var i = 0; i < current.length; i++) {
      current[i].classList.remove('is-active');
      current[i].removeAttribute('aria-current');
    }
    link.classList.add('is-active');
    link.setAttribute('aria-current', 'true');
  }

  function syncActive(root) {
    if (!root || root.__cnsLock || !document.body.contains(root)) return;

    var rows = root.querySelectorAll('.cns-row[id]');
    if (!rows.length) return;

    var marker = markerY(root);
    var current = rows[0];
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getBoundingClientRect().top <= marker + 1) {
        current = rows[i];
      }
    }

    var link = root.querySelector('.cns-nav-link[href="#' + current.id + '"]');
    setActiveLink(root, link);
  }

  function syncAll() {
    for (var i = 0; i < roots.length; i++) {
      syncActive(roots[i]);
    }
  }

  function unlockAndSync(root) {
    root.__cnsLock = false;
    root.__cnsLockTimer = null;
    syncActive(root);
  }

  function lockUntilScrollSettles(root) {
    root.__cnsLock = true;
    if (root.__cnsLockTimer) window.clearTimeout(root.__cnsLockTimer);
    root.__cnsLockTimer = window.setTimeout(function () {
      unlockAndSync(root);
    }, 900);
  }

  function scrollToRow(root, target) {
    var offset = markerY(root);
    var top = target.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0) - offset;
    top = Math.max(0, top);

    try {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (error) {
      window.scrollTo(0, top);
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.cns-nav-link');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    var root = link.closest('.category-nav-splits');
    if (!root) return;

    event.preventDefault();
    setActiveLink(root, link);
    lockUntilScrollSettles(root);
    scrollToRow(root, target);
  });

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncAll();
      });
    },
    { passive: true }
  );

  window.addEventListener('scrollend', function () {
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__cnsLock) unlockAndSync(roots[i]);
    }
  });

  window.addEventListener('resize', function () {
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.__cnsLockTimer) window.clearTimeout(root.__cnsLockTimer);
      root.__cnsLock = false;
    }
    window.requestAnimationFrame(syncAll);
  });

  function bind(root) {
    if (!root || root.__cnsBound) return;
    root.__cnsBound = true;
    roots.push(root);
    syncActive(root);
  }

  function init(scope) {
    var list = (scope || document).querySelectorAll('.category-nav-splits');
    for (var i = 0; i < list.length; i++) {
      bind(list[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('category-nav-splits')) {
      bind(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    roots = roots.filter(function (root) {
      return document.body.contains(root);
    });
  });
})();
